<script setup lang="ts">
import {defineProps, ref, computed} from "vue";

const props = defineProps<{
  listData: Record<string, number>;
  curriculumType: string;
}>();

const showAll = ref(false);

const sortedListData = computed(() => {
  const sorted = Object.entries(props.listData)
    .sort(([, a], [, b]) => b - a)
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {} as Record<string, number>);
  if (showAll.value) {
    return sorted;
  }
  return Object.fromEntries(Object.entries(sorted).slice(0, 5));
});
</script>

<template>
  <div
    v-for="(item, index) in sortedListData"
    :key="index"
    class="metric-tile pa-4 rounded-lg mb-3"
  >
    <v-row class="align-center">
      <v-col cols="auto">
        <span class="font-weight-bold text-h6">
          {{ $t(`curriculums.${curriculumType}.subjects.${index}`) }}
        </span>
      </v-col>
      <v-spacer/>
      <v-col cols="auto">
        <span class="text-h5 font-weight-bold">{{ item }}</span> <br/>
        selections
      </v-col>
    </v-row>
  </div>
  <v-btn class="mt-4 mx-auto" @click="showAll = !showAll" variant="outlined">
    {{ showAll ? 'Hide All' : `Show All (${Object.keys(props.listData).length - 5})` }}
  </v-btn>
</template>
